module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/get_ready_sm-0136f096ed4c0d6466fab4a89f80d0f2.svg";